module.exports = __webpack_public_path__ + "img/dreieckslast.a843a8ce.png";